import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    selectors: {
      '.ms-Button': {
        marginLeft: pxToRem(16),
      },
    },
  },
  cancelButton: {
    fontWeight: 400,
  },
  moduleHeaderText: {
    ...theme.fonts.large,
    selectors: {
      [layout.breakpoints.min.md]: {
        ...theme.fonts.xLarge,
      },
    },
  },
  actionRequired: {
    marginBottom: pxToRem(40),
  },
});
